/**
 * Snapshot history list — small "what runs happened when, and how many ranked" panel
 * that sits below the keyword table on RankTab.
 */
import React from "react";
import { Calendar } from "lucide-react";

export default function HistoryList({ snapshots }) {
  if (snapshots.length === 0) return null;
  return (
    <div className="card-soft">
      <div className="px-5 py-3.5 border-b border-[#edf2f7] flex items-center gap-2">
        <Calendar className="h-3.5 w-3.5 text-[#a0aec0]" />
        <div className="text-[11px] uppercase tracking-widest text-[#a0aec0] font-semibold">History</div>
        <div className="ml-auto text-[10px] text-[#a0aec0] font-mono-tight">{snapshots.length} snapshot(s)</div>
      </div>
      <div className="divide-y divide-[#edf2f7] max-h-72 overflow-y-auto">
        {snapshots.map((s) => {
          const cnt = (s.results || []).filter((r) => r.position != null).length;
          const total = (s.results || []).length;
          return (
            <div
              key={s.id || s.at}
              data-testid={`snapshot-${s.id || s.at}`}
              className="px-5 py-2.5 flex items-center justify-between text-sm"
            >
              <div className="font-mono-tight text-[#4a5568]">{new Date(s.at).toLocaleString()}</div>
              <div className="font-mono-tight text-xs text-[#718096]">
                <span className="text-[#38b2ac] font-semibold">{cnt}</span>/{total} ranking
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
